module.exports = __webpack_public_path__ + "img/group_avatar_guarantee_2.fe228d10.png";